import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import moment from 'moment-jalaali';
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "BarcodePrint",
    components: {
        FormModal,
        Loading,
        BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
        ProductSearch, 
    },
    directives: {
        'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            productSelect: null,  
            stores: [],  
            selectedStore: null,
            varietySelect: null,  
            varieties: [],
        }
    },
    mounted() {
        this.loadStores();
    },
    methods: {
        async loadStores(){
            try {
                const response = await this.$axios.get("admin/stores");
                this.stores = response.data.data.stores;
            } catch (e) {
                this.$root.notify(e);
            } 
        },  
        barcodeVarieties() {
            const shortenedVarieties = this.varieties.map(variety => ({
                id: variety.id,
                product_title: variety.product_title,
                variety_title: variety.title,
                variety_barcode: variety.barcode,
                price: variety.final_price?.amount,
                unit_price: variety.price ?? 0,
                attributes: { ...variety.attributes?.pivot },
                color: variety.color,
                agencyQuantity: variety.customQuantity ? variety.customQuantity : 0,
            }));

            localStorage.setItem('barcodeVarieties', JSON.stringify(shortenedVarieties));
            window.open('/admin/havale-barcodes', '_blank');
        },
        clearVarieties() {  
        this.varieties = [];  
        },  
        selectTheProduct(p) {  
        this.productSelect = p;  
        },  
        selectedVariety(item) {
        this.varietySelect = item; 
        },  
        addVariety() {  
            if (this.varietySelect) {  
                const exists = this.varieties.some(variety => variety.id === this.varietySelect.id);  
                if (exists) {  
                    this.$root.notify(
                    "این تنوع تکراری است.",
                    "warning"
                    );
                    return;
                }  
                this.varieties.push({  
                    ...this.varietySelect,  
                    created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
                    product_title: this.productSelect.title,
                });  
                this.varietySelect = null;
            }else{
                this.productSelect.varieties.forEach(variety => {
                    this.varieties.push({  
                        ...variety,  
                        created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
                        product_title: this.productSelect.title,
                    }); 
                });
                this.varieties.forEach(variety => {
                    variety.customQuantity = variety.all_stores_balance.find(item => item.store_id == this.selectedStore.id) ? 
                        variety.all_stores_balance.find(item => item.store_id == this.selectedStore.id).balance
                        : 0; 
                });
            } 
        },  
        deleteVariety(index) {  
            this.varieties.splice(index, 1);
        },  
    }
}
